(function bootstrapEssencraftHomepageReviewWidget(global) {
  'use strict';

  if (global.ECReviewWidgetHomepage && typeof global.ECReviewWidgetHomepage.initAll === 'function') {
    global.ECReviewWidgetHomepage.initAll(document);
    return;
  }

  const ROOT_SELECTOR = '[data-ec-review-widget-homepage]';
  const PRODUCT_KEYS = ['resin', 'capsules', 'atlas'];

  function emitEvent(name, detail) {
    global.dataLayer = global.dataLayer || [];
    global.dataLayer.push({ event: name, ...detail });
  }

  class HomepageReviewWidget {
    constructor(root) {
      this.root = root;
      this.defaultProduct = PRODUCT_KEYS.includes(root.dataset.defaultProduct)
        ? root.dataset.defaultProduct
        : PRODUCT_KEYS[0];
      this.panels = Array.from(root.querySelectorAll('[data-ec-irw-home-panel]'));
      this.buttons = Array.from(root.querySelectorAll('[data-ec-irw-home-product]'));
      this.status = root.querySelector('[data-ec-irw-home-status]');
      this.activeProduct = null;
      this.abortController = new AbortController();

      this.bindEvents();
      this.selectProduct(this.defaultProduct, false);
      this.root.dataset.ecIrwHomeReady = 'true';
      emitEvent('home_reviews_view', { ec_product: this.defaultProduct });
    }

    panelFor(productKey) {
      return this.panels.find((panel) => panel.dataset.product === productKey) || null;
    }

    activeTab() {
      const panel = this.panelFor(this.activeProduct);
      return panel
        ? panel.querySelector('[data-ec-irw-home-product="' + this.activeProduct + '"]')
        : null;
    }

    bindEvents() {
      const signal = this.abortController.signal;

      this.buttons.forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.selectProduct(button.dataset.ecIrwHomeProduct, true);
            requestAnimationFrame(() => {
              const tab = this.activeTab();
              if (tab) tab.focus();
            });
          },
          { signal }
        );
        button.addEventListener('keydown', (event) => this.handleTabKeydown(event), { signal });
      });

      this.root.addEventListener(
        'click',
        (event) => {
          const target = event.target instanceof Element ? event.target : null;
          const sourceLink = target ? target.closest('a[href*="amazon.com"]') : null;
          if (!sourceLink || !this.root.contains(sourceLink)) return;
          const panel = sourceLink.closest('[data-ec-irw-home-panel]');
          emitEvent('review_source_clicked', {
            ec_product: panel ? panel.dataset.product : this.activeProduct
          });
        },
        { signal }
      );
    }

    handleTabKeydown(event) {
      const currentKey = event.currentTarget.dataset.ecIrwHomeProduct;
      const currentIndex = Math.max(0, PRODUCT_KEYS.indexOf(currentKey));
      let nextIndex = null;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % PRODUCT_KEYS.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + PRODUCT_KEYS.length) % PRODUCT_KEYS.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = PRODUCT_KEYS.length - 1;
      if (nextIndex === null) return;

      event.preventDefault();
      this.selectProduct(PRODUCT_KEYS[nextIndex], true);
      requestAnimationFrame(() => {
        const tab = this.activeTab();
        if (tab) tab.focus();
      });
    }

    selectProduct(productKey, announce) {
      const nextPanel = this.panelFor(productKey);
      if (!nextPanel) return;

      const previousProduct = this.activeProduct;
      const previousPanel = previousProduct ? this.panelFor(previousProduct) : null;
      if (previousPanel && previousPanel !== nextPanel && previousPanel.ecIntelligentReviews) {
        previousPanel.ecIntelligentReviews.closeLibrary();
      }

      this.activeProduct = productKey;
      this.root.dataset.activeProduct = productKey;
      this.panels.forEach((panel) => {
        panel.hidden = panel !== nextPanel;
      });
      this.buttons.forEach((button) => {
        const selected = button.dataset.ecIrwHomeProduct === productKey;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });

      if (global.ECIntelligentReviews && typeof global.ECIntelligentReviews.initAll === 'function') {
        global.ECIntelligentReviews.initAll(nextPanel);
      }

      const productName = nextPanel.dataset.productName || productKey;
      if (this.status) this.status.textContent = 'Showing ' + productName + ' customer reviews.';
      if (announce && previousProduct !== productKey) {
        emitEvent('review_filter_selected', { ec_product: productKey });
      }
    }

    destroy() {
      this.panels.forEach((panel) => {
        if (panel.ecIntelligentReviews) panel.ecIntelligentReviews.destroy();
      });
      this.abortController.abort();
      delete this.root.dataset.ecIrwHomeReady;
    }
  }

  function initRoot(root) {
    if (!(root instanceof HTMLElement) || root.dataset.ecIrwHomeReady === 'true') return;
    root.ecReviewWidgetHomepage = new HomepageReviewWidget(root);
  }

  function initAll(scope) {
    const rootScope = scope || document;
    if (rootScope.matches && rootScope.matches(ROOT_SELECTOR)) initRoot(rootScope);
    rootScope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  global.ECReviewWidgetHomepage = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches && event.target.matches(ROOT_SELECTOR)
      ? event.target
      : event.target.querySelector && event.target.querySelector(ROOT_SELECTOR);
    if (root && root.ecReviewWidgetHomepage) root.ecReviewWidgetHomepage.destroy();
  });
})(window);
